import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@sama/app-state';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Box3, Vector3 } from 'three';
import { AssetBoundingBox } from '../../../team-apis/3d/task-data/asset-bounding-box';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { pointToVector } from '../../utils/point-cloud-utils';

@Component({
  selector: 'h3-modify-asset-bounding-box',
  templateUrl: './modify-asset-bounding-box.component.html',
  styleUrls: ['./modify-asset-bounding-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModifyAssetBoundingBoxComponent extends DirectiveSuperclass {
  assetBoundingBoxStore!: Store<AssetBoundingBox>;
  assetBoundingBoxVolume!: number;

  constructor() {
    super();

    this.assetBoundingBoxStore = inject(PointCloudContentStore)(
      'assetBoundingBox',
    );

    this.subscribeTo(this.assetBoundingBoxStore.$, () => {
      this.updateAssetBoundingBoxVolume();
    });
  }

  private updateAssetBoundingBoxVolume() {
    const assetBoundingBox = this.assetBoundingBoxStore.state();

    const assetBoundingBoxSize = new Box3(
      pointToVector(assetBoundingBox.min),
      pointToVector(assetBoundingBox.max),
    ).getSize(new Vector3());

    this.assetBoundingBoxVolume =
      assetBoundingBoxSize.x * assetBoundingBoxSize.y * assetBoundingBoxSize.z;
  }
}
